<template>
    <svg
        class="block fill-current flex-none"
        :class="iconSize"
    >
        <use :xlink:href="'#' + type" />
    </svg>
</template>
<script>
export default {
    name: 'svg-icon',
    props: {
        type: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: '18'
        },
    },
    computed: {
        iconSize() {
            return `w-${this.size} h-${this.size}`;
        }
    }
}
</script>